import './SingleValueGrid.css';
export var gridRows = '_ln2gar0-2-0-1';